<template>
	<nav class="navbar navbar-expand-lg fixed-top">
		<div class="container-sm">          
			<router-link :to="{ name: 'home' }" class="navbar-brand"><img src="/design/sigofood-images/logo.png" alt="icon" style="height:40px;"></router-link>
			<span class="place">Delivering to</span>
			&nbsp;<span class="text-white" v-if="location && location.place">{{location.place.name}}</span>
			<a class="navbar-brand " href="/location">
				<img src="/design/sigofood-images/angle-down.png" alt="icon" style=" padding: 5px;">
			</a>

			<button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarTogglerDemo02"
			aria-controls="navbarTogglerDemo02" aria-expanded="false" aria-label="Toggle navigation">
				<span class="navbar-toggler-icon"></span>
			</button>
			<div class="navbar-collapse collapse" id="navbarTogglerDemo02">
				<ul class="space d-flex"></ul>

				<ul class="navbar-nav">
					<li class="nav-item d-flex ms-auto">
						<router-link :to="{ name: 'home' }" class="nav-link text-white active">Home</router-link>
					</li>
					<li class="nav-item d-flex ms-auto">
						<!-- <a class="nav-link navitems" href="restaurants.html">Restaurants</a> -->
						<router-link :to="{ name: 'restaurants' }" class="nav-link text-white ">Restaurants</router-link>
					</li>
					<li class="nav-item d-flex ms-auto">
						<!-- <a class="nav-link navitems" href="offers.html">Offers</a> -->
						<router-link :to="{ name: 'offers' }" class="nav-link text-white ">Offers</router-link>

					</li>
					
					<!-- <li v-if="token && session_status" class="nav-item d-flex ms-auto">
						<router-link :to="{ name: 'favorites' }" class="nav-link text-white ">Favorites</router-link>

					</li> -->

					<li v-if="!token" class="nav-item d-flex ms-auto">
						<router-link :to="{ name: 'orders' }" class="nav-link text-white">Orders</router-link>
					</li>									

					<li v-if="token" class="nav-item dropdown d-flex ms-auto ">
						<div class="menu-auth">
							<b-dropdown right variant="link" toggle-class="text-decoration-none" class="btn-account">
								<template #button-content>
								    <img src="/design/sigofood-images/user.png" alt="icon" style="width:30px;height:30px;"> My Account
								</template>	
								<b-dropdown-item><router-link :to="{ name: 'profile' }" class="dropdown-item">Profile</router-link></b-dropdown-item>
								<b-dropdown-item><router-link :to="{ name: 'orders' }" class="dropdown-item">Orders</router-link></b-dropdown-item>
								<b-dropdown-item><router-link :to="{ name: 'favorites' }" class="dropdown-item">Favorites</router-link></b-dropdown-item>
								<!-- <b-dropdown-item><a class="dropdown-item" href="#">Language <small
									style="color: #ee3633;">English</small></a>
								</b-dropdown-item> -->
								<b-dropdown-item><a class="dropdown-item" href="javascript: void(0);" @click.prevent="logout()">Logout</a></b-dropdown-item>
							</b-dropdown>
						</div>
					</li>

					<li v-else class="nav-item d-flex ms-auto">
						<router-link :to="{ name: 'login' }" class="nav-link text-white">Sign In</router-link>
					</li>	

					<li class="nav-item d-flex ms-auto">
						<!-- <a class="nav-link navitems" href="cart.html">Cart</a> -->
						<router-link :to="{ name: 'cart' }" class="nav-link text-white ">
							<div class="cart">
								<span class="count">{{cartCount}}</span>
								<!--   <span class="count">1</span> -->
								<i class="material-icons">shopping_cart</i>
							</div>
						</router-link>
					</li>
				</ul>
			</div>

		</div>
		  <!-- Modal -->
		  <!-- <div class="modal fade " id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">

                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <h5 class="d-grid mx-auto fw-semibold" id="exampleModalLabel">Logout</h5>
                    <div class="text-box">
                        <p class="">Are you sure you want to logout?</p>

                    </div>

                </div>
                <div class="modal-footer">
                    <button type="button" class="btn ok-button " data-bs-toggle="modal"
                        data-bs-target="#exampleModal">No</button>

                        <a  href="signin.html">
                            <button type="button" class="btn ok-button " data-bs-toggle="modal"
                            data-bs-target="#exampleModal">Yes</button>
                        </a>


                </div>
            </div>
        </div>
    </div> -->
	</nav>
</template>

<script>
import auth from '@/firebase/anonymous-signin.js'
import { signInAnonymously } from "firebase/auth";	
export default {
  	name: 'Navbar',
  	props: {
	 	msg: String
  	},
  	data() {
 		return {		
 			token: "",
      		user: {},
			cartCount: 0,
			location: {},
			uid: '',
 		};
 	},

	mounted() {
			let style = document.createElement('link')
			style.setAttribute('rel', 'stylesheet')
			style.setAttribute('href', '/design/custom.css')
			document.head.appendChild(style)
	},

 	created() {
 		this.getUID();
 		this.getToken();
 		this.getLocation();
		this.fetchCartCount();
 	},

  	methods: {

  		getUID() {

			if(localStorage.getItem('sigofood_uid')) {
				this.uid = localStorage.getItem('sigofood_uid');
			} else {
			  signInAnonymously(auth)
			  .then((response) => {
			      if(response.user) {
			        localStorage.setItem('sigofood_uid', response.user.uid); 
			        console.log(response.user.uid);
			      }
			  })
			  .catch((error) => {
			      console.log(error);
			  });

			}
  		},

  		getLocation() {
			if(localStorage.getItem('sigofood_location')) {
				this.location = JSON.parse(localStorage.getItem('sigofood_location'));
				console.log(this.location);
				console.log(localStorage.getItem('sigofood_location'));
			} 
		}, 

  		getToken() {
			if (localStorage.getItem('sigofood_user')) {
				var sigofood_user =  JSON.parse(localStorage.getItem('sigofood_user'));
				if(sigofood_user.token) {
					// if(localStorage.getItem('sigofood_uid')) {
					// 	var local_uid = localStorage.getItem('sigofood_uid');
					// 	alert("local:" + local_uid);
					// 	if(sessionStorage.getItem('sigofood_uid')) {
					// 		var session_uid = sessionStorage.getItem('sigofood_uid');
					// 		alert("session:" + session_uid);
					// 		if(local_uid === session_uid) {
					// 			this.session_status = true;
					// 		} else {
					// 			localStorage.removeItem("sigofood_user");
					// 			this.guestLogin();
					// 		}
					// 	}
					// }
					this.token = sigofood_user.token;
					this.user = sigofood_user;
					//alert(this.token);
					//alert(this.session_status);

				} else {
					this.guestLogin();
				}

			} else {
				this.guestLogin();
			}
		}, 

		guestLogin() {
			// var uid = "";
			// if(localStorage.getItem('sigofood_uid')) {
			// 	uid = localStorage.getItem('sigofood_uid');
			// }

			let url = "guest?device_token=" + this.uid;         
			//this.getToken();
			this.loading = true;
			this.$axios
			.get(url, { headers: { Authorization: "Bearer " + this.token } })
			.then((res) => {
				console.log(res);
				var responseData = res.data.data
				localStorage.setItem('sigofood_guest', JSON.stringify(responseData)); 				  
			})
			.catch((error) => {
				if (error.response) {
               		if(error.response.status == 422) {               
                  if (error.response.data) {
                     this.errors = error.response.data.message;
                  } 
                  this.$swal("", error.response.statusText, "error");
                  
               } else if(error.response.status == 500) {
                  this.$swal("", error.response.statusText, "error");
                  
               } else {
                  this.$swal("", "Something went wrong", "error");
               }
            } else {
               this.$swal("", error.message, "error");
            }
			})
			.finally(() => (this.loading = false));
		},

  		logout() {

  			this.$bvModal.msgBoxConfirm('Are you sure you want to logout?', {
          	title: 'Logout',
          	size: 'sm',
          	buttonSize: 'sm',
          	okVariant: 'danger',
          	okTitle: 'YES',
          	cancelTitle: 'NO',
          	footerClass: 'p-2',
          	hideHeaderClose: true,
          	centered: true
        	})
          	.then(value => {
            	if(value) {
          	
					let url = "login/logout";         
					//this.getToken();
					this.loading = true;
					let formData = new FormData();
					this.$axios
					.post(url, formData,  { headers: { Authorization: "Bearer " + this.token } })
					.then((res) => {
						console.log(res);
						var responseData = res.data.data;
						console.log(responseData);

						if(localStorage.getItem('sigofood_user')) {
							localStorage.removeItem("sigofood_user");    
						}         
						this.$swal("", "You have been successfully logged out", "success");
						this.$router.push({ name: "login" });
					})
					.catch((error) => {
						if (error.response) {
               				if(error.response.status == 422) {               
                  				if (error.response.data) {
                     				this.errors = error.response.data.message;
                  				} 
                  				this.$swal("", error.response.statusText, "error");
                  
               				} else if(error.response.status == 500) {
                  				this.$swal("", error.response.statusText, "error");
                  
               				} else {
                  				this.$swal("", "Something went wrong", "error");
               				}
            			} else {
               				this.$swal("", error.message, "error");
            			}
					})
					.finally(() => (this.loading = false));
				}

			})
          	.catch(err => {
            	console.log(err);
          	})
		},

		fetchCartCount() {
			
			if(this.user) {
				this.getToken();
				if(localStorage.getItem('sigofood_uid')) {
						this.uid = localStorage.getItem('sigofood_uid');  
					} 

				const config = {
				headers: {
					"Content-type": "multipart/form-data",
					"Accept": "application/json",
					"Authorization": "Bearer " + this.token,

				},
				};
				let url = "cart/getCount?uid=" + this.uid + "&device_token=" + this.uid;          
				

				this.$axios
					.get(url, config)
					.then((res) => {
						if(res.status == 200) {
							var responseData = res.data;
							console.log(responseData);
							this.cartCount = responseData.data;

							//console.log(this.cartCount);
							// this.fetchExtras();
							
						} else {
							this.$swal("", "Something went wrong", "error");
						}                  
				})
				.catch((error) => {
					if (error.response) {
						if(error.response.status == 422) {               
							if (error.response.data) {
							this.errors = error.response.data.message;
							} 
							this.$swal("", error.response.statusText, "error");
							
						} else if(error.response.status == 500) {
							this.$swal("", error.response.statusText, "error");

						} else if(error.response.status == 401) {
							localStorage.removeItem("sigofood_user");
							localStorage.removeItem("sigofood_uid");
							this.$router.push({ name: "home" });  
							
						} 
						// else {
						// 	this.$swal("", "Something went wrong", "error");
						// }
					// } else {
					// 	this.$swal("", error.message, "error");
					}
				})
				.finally(() => (this.loading = false));

			} else {
				// var uid = "";
				// if(localStorage.getItem('sigofood_uid')) {
				// 	uid = localStorage.getItem('sigofood_uid');
				// }
				const config = {
					headers: {
						"Content-type": "multipart/form-data",
						"Accept": "application/json",
						"Authorization": "Bearer ",
					},
				};

				// let url = "cart/getCount?uid=" + uid + "&device_token=" + uid;  
				let url = "guest/getCartCount";   

				this.$axios
					.get(url, config)
					.then((res) => {
						if(res.status == 200) {
							var responseData = res.data;
							console.log(responseData);
							this.cartCount = responseData.data;

							//console.log(this.cartCount);

						} else {
							this.$swal("", "Something went wrong", "error");
						} 
					})
					.catch((error) => {
						if (error.response) {
							if(error.response.status == 422) {               
								if (error.response.data) {
								this.errors = error.response.data.message;
								} 
								this.$swal("", error.response.statusText, "error");
										
							} else if(error.response.status == 500) {
								this.$swal("", error.response.statusText, "error");										
							} else {
									this.$swal("", "Something went wrong", "error");
								}
						} else {
							this.$swal("", error.message, "error");
						}
					})
					.finally(() => (this.loading = false));
			}
		} 
  }
}
</script>
   

